package org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.closing_reports.FinalReportsGroupEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_model.ClosingReportItem
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.PeriodDaysEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.closing_report.CloseDailyReportUseCase
import org.hs_soft.runmynesto.domain.usecase.closing_report.ClosingReportDetailUseCase
import org.hs_soft.runmynesto.domain.usecase.closing_report.ClosingReportsUseCase
import org.hs_soft.runmynesto.domain.usecase.closing_report.PrintClosingReportsUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetCompanyProfileIdUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.downloadFile
import org.hs_soft.runmynesto.domain.util.extractAllDevicesIds
import org.hs_soft.runmynesto.domain.util.getFromDate
import org.hs_soft.runmynesto.domain.util.getToDate
import org.hs_soft.runmynesto.domain.util.getUpdatedSelectedYear
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel

class ClosingReportsViewModel(
    private val requestManager: RequestManager,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val closingReportsUseCase: ClosingReportsUseCase,
    private val closingReportDetailUseCase: ClosingReportDetailUseCase,
    private val getCompanyProfileIdUseCase: GetCompanyProfileIdUseCase,
    private val printClosingReportsUseCase: PrintClosingReportsUseCase,
    private val closeDailyReportUseCase: CloseDailyReportUseCase,
):BaseViewModel()
{
    private val _state = MutableStateFlow(ClosingReportsState())
    val state: StateFlow<ClosingReportsState> = _state
    private var tempCheckoutList: List<Children>? = listOf()
    private var tempClosingReportsList:List<ClosingReportItem> ?= null


    override  fun clear() {
        super.clear()
        requestManager.cancelAll()
    }

    init {
//        initCalendar()
    }

//    private fun initCalendar()
//    {
//        val today = Clock.System.now().toLocalDateTime(TimeZone.UTC).date
//        _state.value = _state.value.copy(
//            defaultDate = MonthModel(
//                dayNumber = today.dayOfMonth,
//                monthName = today.month.name,
//                yearNumber = today.year,
//                monthNumber = today.monthNumber
//            ),
//
//        )
//        _state.value=_state.value.copy(
//            selectedFromDate = state.value.defaultDate?.let { getFromDate(it) },
//            selectedToDate = state.value.defaultDate?.let { getFromDate(it) }
//        )
//    }


    fun onEvent(event: ClosingReportsEvent) {
        when (event) {

            is ClosingReportsEvent.DismissErrorDialog->{
                    _state.value=_state.value.copy(
                        errorInfo = null,
                    )
            }

            is ClosingReportsEvent.SetToCalendarFilterDialogStatus->{
                setCalendarFromFilterDialogStatus(status=event.status)
            }
            is ClosingReportsEvent.SetFromCalendarFilterDialogStatus->{
                setCalendarToFilterDialogStatus(status=event.status)
            }
            is ClosingReportsEvent.OnSelectFromDate->{
                onSelectFromDate(
                    selectedDate = event.selectedDate,
                )
            }
            is ClosingReportsEvent.OnSelectToDate->{
                onSelectToDate(
                    selectedDate = event.selectedDate,
                )
            }


            is ClosingReportsEvent.SetClosingDailyReportDialogStatus->{

                setClosingDailyReportDialogStatus(event.status)
            }

            is ClosingReportsEvent.CloseDailyReport->{
                closeDailyReport(
                    id=state.value.selectedClosingReport
                        ?.data?.cashAssist?.getClosing?.id,
                    reason=event.reason,
                )
            }

            is ClosingReportsEvent.SetFinancialFilterDialog->{
                _state.value=_state.value.copy(
                    financialFilterDialogShowingStatus = event.status
                )
            }

            is ClosingReportsEvent.ExtractAllDevicesIds->{
                _state.value=_state.value.copy(
                    selectedCashRegisterIds = extractAllDevicesIds( state.value.cashList)
                )
            }

            is ClosingReportsEvent.UpdateCashRegisterIds->{
                updateCashRegisterIds(cashRegisterIds=event.newCashRegisterIds)
            }


            is ClosingReportsEvent.SubmitFinancialGroup->{
                submitSelectingFinancialGroup(
                    group=event.group
                )
            }

            is ClosingReportsEvent.SetFinancialGroupStatus->{
                setFinancialGroup(status=event.status)
            }

            is ClosingReportsEvent.OnChangePageClick->{
                _state.value=_state.value.copy(
                    showFirstPage = !state.value.showFirstPage
                )
            }

            is ClosingReportsEvent.SetCompanyProfileId->{
                _state.value=_state.value.copy(
                    companyProfileId = getCompanyProfileIdUseCase()
                )
            }

            is ClosingReportsEvent.SetNewCalendarHeaderYear->{
                _state.value=_state.value.copy(
                    selectedCalendarHeaderYear = event.year
                )
            }



            is ClosingReportsEvent.OnClosingReportClick->{
                onClosingReportClick(id = event.id)
            }
            is ClosingReportsEvent.SearchInClosingReports->{
                searchInClosingReports(value = event.value)
            }

            is ClosingReportsEvent.OnSearchCheckoutItems->{
                searchCheckoutItems(value=event.value)
            }


            is ClosingReportsEvent.SubmitClosingReportsCalendarFilter->{
                submitClosingReportsCalendarFilter(
                    from=event.from,
                    to=event.to,
                    cashRegisterIds=event.cashRegisterIds,
                )

            }

            is ClosingReportsEvent.SubmitClosingReportsDaysFilter->{
                submitClosingReportsDaysFilter(
                    from=event.from,
                    to=event.to,
                    selectedPeriodType=event.periodDaysType,
                    cashRegisterIds = event.cashRegisterIds,

                )


            }

            is ClosingReportsEvent.GetCheckoutData -> {
                getCheckoutData()
            }
            is ClosingReportsEvent.GetClosingReports -> {
                getClosingReports(
                    from=event.from,
                    to=event.to,
                    cashRegisterIds = event.cashRegisterIds,
                )
            }


            is ClosingReportsEvent.SetReportsTableAndDevicesVisibilityStatus->{
                _state.value=_state.value.copy(
                    showReportsTableAndDevices = event.showReportsTableAndDevices
                )
            }

            is ClosingReportsEvent.SetDaysFilterDialogStatus->{
                _state.value=_state.value.copy(
                    showDaysFilterDialog = event.show,
                    showFromCalendarFilterDialog = false,
                    showToCalendarFilterDialog = false,
                )
            }
        }
    }

    private fun setClosingDailyReportDialogStatus(status:Boolean) {
        _state.value = _state.value.copy(
            showClosingDailyReportDialog = status,
            dailyClosingDialogLoading = false
        )
        closeDailyReportUseCase.cancel()
    }

    private fun setCalendarFromFilterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showFromCalendarFilterDialog = status,
            showDaysFilterDialog = false,
            showToCalendarFilterDialog = false
        )
    }

    private fun setCalendarToFilterDialogStatus(status: Boolean) {
        _state.value = _state.value.copy(
            showToCalendarFilterDialog = status,
            showDaysFilterDialog = false,
            showFromCalendarFilterDialog = false,
        )
    }


    private fun onSelectFromDate(
        selectedDate: MonthModel,
    ) {
        _state.value=_state.value.copy(
            selectedFromDate = getFromDate( selectedDate),
        )
        if (state.value.selectedToDate!=null && state.value.selectedFromDate!=null){
            getClosingReports(
                from = state.value.selectedFromDate?:"",
                to=state.value.selectedToDate?:"",
                cashRegisterIds = state.value.selectedCashRegisterIds?: listOf()
            )
        }
    }

    private fun onSelectToDate(
        selectedDate: MonthModel,
    ) {
        _state.value=_state.value.copy(
            selectedToDate = getToDate( selectedDate)
        )
        if (state.value.selectedToDate!=null && state.value.selectedFromDate!=null){
            getClosingReports(
                from = state.value.selectedFromDate?:"",
                to=state.value.selectedToDate?:"",
                cashRegisterIds = state.value.selectedCashRegisterIds?: listOf()
            )
        }
    }

    private fun submitSelectingFinancialGroup(
        group: FinalReportsGroupEnum,
    ) {
        _state.value=_state.value.copy(
            selectedFinancialGroup = group
        )

        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(financialGroupDialogLoading = isLoading)
                },
                callRequest = {
                    val checkOutData = getSavedCheckOutUseCase()?.data?.cashAssist?.children

                    val departments = mutableSetOf<String>()

                    checkOutData?.forEach { children ->
                        // Check if any childrenXXX.id is in selectedCashRegisterIds
                        val hasMatchingChild = children.children?.any { childrenX ->
                            childrenX.children?.any { childrenXX ->
                                childrenXX.children.any { childrenXXX ->
                                    state.value.selectedCashRegisterIds?.contains(childrenXXX.id) == true
                                }
                            } == true
                        } == true

                        // If a match is found, add the department name to the set
                        if (hasMatchingChild && children.name!=null) {
                            departments.add(children.name)
                        }
                    }

                    printClosingReportsUseCase(
                        from = state.value.selectedFromDate?:"",
                        to = state.value.selectedToDate?:"",
                        departments = departments.toMutableList(),
                        groupBy = group.value,
                        cacheKey = state.value.printedClosingReports?.data
                            ?.reports?.getClosingsReport?.pagination?.cacheKey
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        printedClosingReports = result
                    )
                    val url = result.data?.reports?.getClosingsReport?.url

                    if (url != null) {
                        val fileName = "closingReports.pdf"
                        downloadFile(
                            url = url,
                            fileName = fileName
                        )
                        _state.value = _state.value.copy(
                            showFinancialGroupDialog = false,
                            financialFilterDialogShowingStatus = false
                        )
                    } else {
                        submitSelectingFinancialGroup(group = group)
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun closeDailyReport(
        id: String?,
        reason: String,
    ) {
        if (id!=null) {
            val currentDateTime = Clock.System.now().toLocalDateTime(TimeZone.UTC).toString()+"Z"

            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(dailyClosingDialogLoading = isLoading)
                    },
                    callRequest = {
                        closeDailyReportUseCase(
                            id = id,
                            reason = reason,
                            date = currentDateTime
                        )
                    },
                    onSuccess = {
                        _state.value = _state.value.copy(
                            showClosingDailyReportDialog = false,
                            financialFilterDialogShowingStatus = false
                        )

                        getClosingReports(
                            from = state.value.selectedFromDate?:"",
                            to = state.value.selectedToDate?:"",
                            cashRegisterIds = state.value.selectedCashRegisterIds?: listOf()
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun onClosingReportClick(
        id:String
    ){
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    closingReportDetailUseCase(id=id)
                },
                onSuccess = { result ->
                    _state.value=_state.value.copy(
                        selectedClosingReport= result,
                        showFirstPage = false
                    )
                    tempClosingReportsList=state.value.closingReports
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getClosingReports(
        from: String,
        to: String,
        cashRegisterIds:List<String>,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    closingReportsUseCase(
                        from=from,
                        to = to,
                        cashRegisterIds=cashRegisterIds
                    )
                },
                onSuccess = { result ->
                    _state.value=_state.value.copy(
                        closingReports=result.data?.cashAssist?.listClosings?.items,
                        showToCalendarFilterDialog = false,
                        showFromCalendarFilterDialog = false,
                        showDaysFilterDialog = false
                    )
                    if (state.value.selectedClosingReport==null){
                        if (!_state.value.closingReports.isNullOrEmpty()){
                            onClosingReportClick(
                                _state.value.closingReports?.get(0)?.id?:""
                            )
                        }else{
                            _state.value=_state.value.copy(
                                selectedClosingReport = null
                            )
                        }
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }


    private fun updateCashRegisterIds(cashRegisterIds: List<String>) {
         _state.value=_state.value.copy(
             selectedCashRegisterIds = cashRegisterIds
         )

        if (state.value.selectedFromDate != null) {

            getClosingReports(
                from = state.value.selectedFromDate?:"",
                to=state.value.selectedToDate?:"",
                cashRegisterIds=state.value.selectedCashRegisterIds?: listOf(),
            )

        }

    }


    private fun setFinancialGroup(status: Boolean) {
        _state.value=_state.value.copy(
            showFinancialGroupDialog = status,
            financialGroupDialogLoading =false
        )
    }



    private fun submitClosingReportsDaysFilter(
        from: String,
        to: String,
        selectedPeriodType: PeriodDaysEnum,
        cashRegisterIds: List<String>
    ) {
        _state.value=_state.value.copy(
            showDaysFilterDialog = false,
            selectedFromDate = from,
            selectedToDate = to,
            selectedPeriodType = selectedPeriodType,
        )



        getClosingReports(
            from= from,
            to= to,
            cashRegisterIds = cashRegisterIds,
        )

    }

    private fun submitClosingReportsCalendarFilter(
        from: String,
        to: String,
        cashRegisterIds: List<String>
    ) {

        _state.value=_state.value.copy(
            selectedToDate =  to.getUpdatedSelectedYear(state.value.selectedCalendarHeaderYear),
            selectedFromDate = from.getUpdatedSelectedYear(state.value.selectedCalendarHeaderYear),
        )

        getClosingReports(
            from= _state.value.selectedFromDate?:"",
            to= _state.value.selectedToDate?:"",
            cashRegisterIds = cashRegisterIds,
        )
    }


    private fun searchInClosingReports(value: String) {
        _state.value = _state.value.copy(closingReports = tempClosingReportsList)

        val newData = _state.value.closingReports?.filter { model ->
            val dateMatches = model.dateTime?.contains(value, ignoreCase = true) ?: false
            val numberMatches = model.number.toString().contains(value, ignoreCase = true)
            val cashRegisterMatches = model.cashRegister?.name?.contains(value, ignoreCase = true) ?: false
            val totalMatches = model.total.toString().contains(value, ignoreCase = true)

            dateMatches || numberMatches || cashRegisterMatches || totalMatches
        }

        _state.value = _state.value.copy(
            closingReports = newData
        )
    }
    private fun searchCheckoutItems(value: String)
    {
        _state.value= _state.value.copy(cashList =tempCheckoutList )

        if (value == "") {
            _state.value = _state.value.copy(isDevicesExpandAll = false,)
        } else {
            val searchedList = ArrayList<Children>()
            state.value.cashList?.forEach { model ->
                var matchFound = model.name?.lowercase()?.contains(value.lowercase()) ?: false
                model.children?.forEach { childX ->
                    if (childX.name?.lowercase()?.contains(value.lowercase()) == true) {
                        matchFound = true
                    }
                    childX.children?.forEach { childXX ->
                        if (childXX.name?.lowercase()?.contains(value.lowercase()) == true) {
                            matchFound = true
                        }
                        childXX.children.forEach {childXXX->
                            if (childXXX.name?.lowercase()?.contains(value.lowercase()) == true) {
                                matchFound = true
                            }
                        }
                    }
                }
                if (matchFound) {
                    searchedList.add(model)
                }
            }


            _state.value=_state.value.copy(
                isDevicesExpandAll = true,
                cashList = searchedList
            )

        }
    }



    private fun getCheckoutData() {
         launch {
            if (state.value.cashList==null){

                val result=getSavedCheckOutUseCase()

                _state.value=_state.value.copy(
                    cashList = result?.data?.cashAssist?.children
                )
                tempCheckoutList=state.value.cashList

            }

        }

    }


    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }
}